// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QueryFilters.TripFilters {
  gap: 8rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Trips/components/TripFilters/styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF","sourcesContent":[".QueryFilters.TripFilters {\n  gap: 8rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
